import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import styles from './LevelsHint.module.scss';

const LevelsHint = ({ languages, withHelp, className }) => {
  const { t } = useTranslation('common');

  return (
    <div className={cn(styles.wrapper, className)}>
      {languages ? (
        <ul className={styles.levels}>
          <li className={styles.level1}>{t('languageLevel.1')}</li>
          <li className={styles.level1_2}>{t('languageLevel.2')}</li>
          <li className={styles.level2}>{t('languageLevel.3')}</li>
          <li className={styles.level2_2}>{t('languageLevel.4')}</li>
          <li className={styles.level3}>{t('languageLevel.5')}</li>
          <li className={styles.level3_2}>{t('languageLevel.6')}</li>
        </ul>
      ) : (
        <ul className={styles.levels}>
          <li className={styles.level1}>{t('tag.level-1')}</li>
          <li className={styles.level2}>{t('tag.level-2')}</li>
          <li className={styles.level3}>{t('tag.level-3')}</li>
        </ul>
      )}
      {withHelp && (
        <div className={styles.help}>
          ({t('tag.help')})
        </div>
      )}
    </div>
  );
};

LevelsHint.propTypes = {
  languages: PropTypes.bool,
  withHelp: PropTypes.bool,
  className: PropTypes.string,
};

LevelsHint.defaultProps = {
  languages: false,
  withHelp: false,
  className: null,
};

export default LevelsHint;
